module.exports = __webpack_public_path__ + "img/img-6.fe09c76b.png";